import React from 'react';

export const Header: React.FC = () => {
  return (
    <header className="py-8 md:py-12">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <img
            src="/Logo.png"
            alt="Coffee On Cue"
            className="h-12 md:h-16 w-auto"
          />
        </div>

        {/* Hero */}
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-offblack">
            Workplace Coffee
            <br />
            ROI Calculator
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
            Discover the productivity gains and sustainability impact of
            on-site coffee service for your workplace.
          </p>
        </div>
      </div>
    </header>
  );
};
